module.exports = __webpack_public_path__ + "static/media/REV.55395513.svg";